import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://airnerilsoslbjmivezu.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFpcm5lcmlsc29zbGJqbWl2ZXp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3NDkwODksImV4cCI6MjA2MzMyNTA4OX0.eEWfD68snhXwypyY_c67lP6TBSo7t6B8h86wo3hrdpQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
